<template>
   <b-form @submit.prevent="submit">
      <b-form-group
         label="Business Component Name"
         label-for="input-project-name"
         invalid-feedback="Required"
      >
         <b-form-input
            id="input-project-name"
            v-model="project.name"
            :state="validation.name.$invalid ? false : null"
            ref="name"
         ></b-form-input>
      </b-form-group>
      <b-form-group label="Description" label-for="input-project-description">
         <b-form-textarea
            id="input-project-description"
            v-model="project.description"
            placeholder="Enter Description"
         ></b-form-textarea>
      </b-form-group>
      <b-form-group label="Type" label-for="radio-project-type" invalid-feedback="Required">
         <b-form-radio-group id="radio-project-type" v-model="project.ptype" stacked>
            <b-form-radio
               v-for="(name, key, idx) in ProjectType"
               :id="`radio-project-type-${idx + 1}`"
               :key="key"
               :value="key"
            >
               {{ name }}
               <b-icon icon="question-circle" v-b-tooltip.right="ProjectTypeDescription[key]">
               </b-icon>
            </b-form-radio>
         </b-form-radio-group>
      </b-form-group>

      <b-form-group label="Applicable Periods" v-if="studyPeriods.length > 0">
         <b-form-checkbox id="checkbox-all-periods" @change="onSelectAll"
            >Select All</b-form-checkbox
         >
         <hr class="my-2" />
         <b-form-checkbox-group
            id="group-periods"
            multiple
            v-model="project.periodIds"
            :options="periodOptions"
            stacked
         ></b-form-checkbox-group>
      </b-form-group>
   </b-form>
</template>

<script>
import {mapGetters} from 'vuex';
import {sortByNullable} from '@/helpers/utils';
import {ProjectType} from '@/store/modules/projects';

const ProjectTypeDescription = Object.freeze({
   PRODUCT:
      'A tangible good or physical product developed or improved through research and development.',
   SW_NON_INTERNAL: 'Software developed primarily for sale, lease, or license to customers.',
   SW_INTERNAL:
      'Software created for internal business operations and not intended for external sale or licensing.',
   SW_INTERNAL_EXEMPT:
      'Internal-use software that qualifies for exemption due to significant innovation or uncertainty in development.',
   SW_DUAL: 'Software serving both internal operational purposes and external commercial use.',
   PROCESS:
      'A series of actions, methods, or procedures developed or improved to enhance production, manufacturing, or business operations.',
   OTHER: "All other R&D that doesn't fit within another business component type, such as experimental projects or conceptual developments.",
});

export default {
   props: {
      project: Object,
      validation: Object,
   },

   data() {
      return {
         ProjectType,
         ProjectTypeDescription,
      };
   },

   computed: {
      ...mapGetters({
         studyPeriods: 'companies/studyPeriods',
      }),
      periodOptions() {
         return [...this.studyPeriods]
            .sort(sortByNullable('startDate', {nulls: 'last'}))
            .map((period) => ({
               value: period.id,
               text: period.label,
               disabled: !period.study.isOpen,
            }));
      },
   },

   methods: {
      onSelectAll(select) {
         if (select) {
            this.project.periodIds = this.studyPeriods
               .filter((period) => {
                  return (
                     period.study.isOpen ||
                     (!period.study.isOpen && this.project.periodIds.includes(period.id))
                  );
               })
               .map((period) => period.id);
         } else {
            this.project.periodIds = this.studyPeriods
               .filter((period) => {
                  return !period.study.isOpen && this.project.periodIds.includes(period.id);
               })
               .map((period) => period.id);
         }
      },

      /** Emit a 'submit' event */
      submit() {
         this.$emit('submit');
      },

      /** Focus the name input (used externally) */
      focusName() {
         this.$refs.name.focus();
      },
   },
};
</script>
